
const initialState = {
  tires: [],
  loading: false
};

export function fetchTires(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_TIRES.SUCCESS':
      return {
        ...state,
        tires:  action.tires.body
      };
    default:
      return state
  }
}

export function saveTires(state = initialState, action) {
  switch (action.type) {
    case 'SAVE_TIRES.SUCCESS':
      return {
        ...state,
        tires:  action.tires.body,
      };
    default:
      return state
  }
}
